module.exports = __webpack_public_path__ + "media/img/uploads/solutions-slant-outdoor-recreation-63fdce9e528255c21304d04100cc8b66.jpg";